import { createAction, props } from "@ngrx/store";
import { RankListItemMessage, RankListResponseWrapper } from "src/app/api/models";

export enum RanklistActionTypes {
    LOAD_RANKLIST = '[Ranklist] load many',
    LOAD_RANKLIST_FAIL = '[Ranklist] load many fail',
    LOAD_RANKLIST_SUCCESS = '[Ranklist] load many success',
}

export const loadMany = createAction(RanklistActionTypes.LOAD_RANKLIST, props<{ month: string, roomId: string, level: string, nameSpace: string }>());
export const loadManyFail = createAction(RanklistActionTypes.LOAD_RANKLIST_FAIL, props<{ error: object }>());
export const loadManySuccess = createAction(RanklistActionTypes.LOAD_RANKLIST_SUCCESS, props<{ items: RankListResponseWrapper[] }>());